import React from "react";
import PropTypes from "prop-types";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment, IconButton } from "@mui/material";

export function ShowPasswordButton({ handleClickShowPassword, isPasswordVisible, ...rest }) {
    return (
        <InputAdornment position="end">
            <IconButton
                aria-label={isPasswordVisible ? "Hide password" : "Show password"}
                onClick={handleClickShowPassword}
                edge="end"
                {...rest}
                size="large"
            >
                {isPasswordVisible ? <Visibility /> : <VisibilityOff />}
            </IconButton>
        </InputAdornment>
    );
}

ShowPasswordButton.propTypes = {
    handleClickShowPassword: PropTypes.func.isRequired,
    isPasswordVisible: PropTypes.bool.isRequired
};
